"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var defaultStyles = function (theme) {
    return {
        root: {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        },
        menuContainer: {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            height: 40,
            zIndex: 20000,
            // this is pretty shitty - basically trying to pave over the lack of @uifabric/styling use for command bar
            selectors: {
                "&.rootView": {
                    selectors: {
                        ".ms-CommandBar": {
                            backgroundColor: theme.palette.neutralDark,
                            selectors: {
                                ".ms-CommandBarItem": {
                                    ":hover": {
                                        backgroundColor: theme.palette.neutralPrimary
                                    },
                                    selectors: {
                                        ".ms-CommandBarItem-text": {
                                            backgroundColor: theme.palette.neutralDark,
                                            color: theme.palette.neutralLighter
                                        },
                                        ".ms-CommandBarItem-link": {
                                            backgroundColor: theme.palette.neutralDark,
                                            color: theme.palette.neutralLighter,
                                            selectors: {
                                                ".ms-CommandBarItem-icon": {
                                                    color: theme.palette.neutralLighter
                                                },
                                                ".ms-CommandBarItem-chevronDown": {
                                                    color: theme.palette.neutralLighter
                                                },
                                                ":hover": {
                                                    backgroundColor: theme.palette.neutralPrimary
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        main: {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            overflow: "auto",
            selectors: {
                "&.hasMenu": {
                    top: 40
                }
            }
        }
    };
};
exports.defaultStyles = defaultStyles;
var Defaults = {
    styles: defaultStyles
};
exports.Defaults = Defaults;
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    return styling_1.concatStyleSets(Defaults.styles(theme || styling_1.getTheme()), customStyles);
});
exports.getStyles = getStyles;
